import {VotingType} from "@/entities/voting/VotingType";
import {NewEntityVotingModel} from "@/entities/voting/NewEntityVotingModel";

export class NewToolVotingModel extends NewEntityVotingModel {
    type: VotingType = VotingType.addTool;
    newTool: { name: string };

    constructor(branchId: number, name: string) {
        super(branchId);
        this.newTool = { name: name };
    }
}

